import { render, staticRenderFns } from "./StockXlsx.vue?vue&type=template&id=bf3e8a5e&"
import script from "./StockXlsx.vue?vue&type=script&lang=js&"
export * from "./StockXlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports